
const IN = 'In'
const OUT = 'Out'

export default {
  IN,
  OUT,
  valid: (v) => [IN, OUT].indexOf(v) !== -1
}
